"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Table;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactImageFallback = _interopRequireDefault(require("react-image-fallback"));

var _styles = require("./styles");

var _defaultProfileImage = _interopRequireDefault(require("../../../../../assets/images/defaultImages/defaultProfileImage.svg"));

var _jsxRuntime = require("react/jsx-runtime");

function Table(_ref) {
  var images = _ref.images;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      indexHover = _useState2[0],
      setIndexHover = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MainContainer, {
    children: images.map(function (image, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Image, {
        onMouseEnter: function onMouseEnter() {
          return setIndexHover(i);
        },
        onMouseLeave: function onMouseLeave() {
          return setIndexHover();
        },
        index: i,
        children: [image.id !== -1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageFallback.default, {
          src: image.src,
          fallbackImage: _defaultProfileImage.default,
          className: "img"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CounterExtra, {
          children: image.src
        }), indexHover === i && image.name && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NameHover, {
          index: i,
          children: image.name
        })]
      }, image.id);
    })
  });
}